export default __webpack_public_path__ + "static/media/garden-loader.5a610133.gif";